import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeSubclassReadAction from './cnaeSubclassRead.action.json' assert { type: 'json' }

const cnaeSubclassReadDefinition = defineReadAutoAction(cnaeSubclassReadAction, 'cnaeSubclass')

export default cnaeSubclassReadDefinition
